import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbar,
} from "@material-ui/data-grid";
import { Constants } from "../../config/constants";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";
import Backdrop from "@material-ui/core/Backdrop";
import { useSelector } from "react-redux";
import { ReactComponent as Close } from "../../assets/svg/close_black_24dp.svg";
import { authData } from "../../redux/auth/authSlice";
import config from "../../config/aws-exports";
import { API } from "aws-amplify";
import CircularProgress from "@material-ui/core/CircularProgress";
import SearchIcon from "@material-ui/icons/Search";

function CustomToolbar() {
  return (
    <GridToolbarContainer
      style={{ display: "flex", justifyContent: "flex-end" }}
    >
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

const useStyles = makeStyles({
  root: {
    "& .super-app-theme--header": {
      backgroundColor: Constants.main_color_1,
      fontSize: "16px",
      color: "rgb(255,255,255)",
      fontFamily: "nunito",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
  },
  ".MuiDataGrid-root": {
    fontSize: "14px",
    fontFamily: "nunito",
    fontWeight: 400,
    color: "black",
  },
});
const WeeklyReport = () => {
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [openAssign, setOpenAssign] = useState(false);

  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Initialize state with default dates
  const [startDate, setStartDate] = useState(formatDate(firstDayOfMonth));
  const [endDate, setEndDate] = useState(formatDate(today));
  const [showButton, setShowButton] = useState(false);
  const [rows, setRows] = useState([]);
  const [rowsModal1, setRowsModal1] = useState([]);
  const [rowsModal2, setRowsModal2] = useState([]);
  const [spin, setSpin] = useState(false);
  const [searchText, setSearchText] = useState("");
  let userDetails = useSelector(authData);
  useEffect(() => {
    getLernersReport();
  }, []);

  const tcolumns = [
    {
      field: "col1",
      headerName: "University",
      flex: 1,
      headerClassName: "super-app-theme--header",

      renderCell: (params) => (
        <div tabIndex={0} title={params.value} className="cursor-pointer">
          <span>{params.value}</span>
        </div>
      ),
      // renderCell: (params) => {
      //   return (

      //     <div tabIndex={0} title={formattedDate} className="cursor-pointer">
      //     <p>{params.value}</p>
      //     </div>
      //   )
      // }
    },
    {
      field: "col2",
      headerName: "Program",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <div tabIndex={0} title={params.value} className="cursor-pointer">
          <span>{params.value}</span>
        </div>
      ),
    },
    {
      field: "col3",
      headerName: "Academic schedule",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <div tabIndex={0} title={params.value} className="cursor-pointer">
          <span>{params.value}</span>
        </div>
      ),
    },
    {
      field: "col4",
      headerName: "Current Semester",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <div tabIndex={0} title={params.value} className="cursor-pointer">
          <span>{params.value}</span>
        </div>
      ),
    },
    {
      field: "col15",
      headerName: "Enrolled",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <div tabIndex={0} title={params.value} className="cursor-pointer">
          <span>{params.value}</span>
        </div>
      ),
    },
    {
      field: "col6",
      headerName: "Live Classes",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <div tabIndex={0} title={params.value} className="cursor-pointer">
          <span>{params.value}</span>
        </div>
      ),
    },
    {
      field: "col7",
      headerName: "LMS Login",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <div tabIndex={0} title={params.value} className="cursor-pointer">
            <p
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleClickOpen();
              }}
            >
              {params.value}
            </p>
          </div>
        );
      },
    },
    {
      field: "col8",
      headerName: "Assignment Submission",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <div tabIndex={0} title={params.value} className="cursor-pointer">
            <p
              style={{ cursor: "pointer" }}
              onClick={() => {
                setOpenAssign(true);
              }}
            >
              {params.value}
            </p>
          </div>
        );
      },
    },
    {
      field: "col9",

      headerName: "End Sem Exam",
      flex: 1,
      headerClassName: "super-app-theme--header",
    },
  ];

  const tcolumnsmodal1 = [
    {
      field: "col1",
      headerName: "UserName",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        <div tabIndex={0} title={params.value} className="cursor-pointer">
        <span>{params.value}</span>
      </div>
      }
    },
    {
      field: "col2",
      headerName: "Email Id",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        <div tabIndex={0} title={params.value} className="cursor-pointer">
        <span>{params.value}</span>
      </div>
      }
    },
  ];

  const tcolumnsmodal2 = [
    {
      field: "col1",
      headerName: "Submitted By",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        <div tabIndex={0} title={params.value} className="cursor-pointer">
          <span>{params.value}</span>
        </div>
      }
    },
    {
      field: "col2",
      headerName: "Email Id",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        <div tabIndex={0} title={params.value} className="cursor-pointer">
          <span>{params.value}</span>
        </div>
      }
    },
    {
      field: "col3",
      headerName: "Submitted On",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        <div tabIndex={0} title={params.value} className="cursor-pointer">
        <span>{params.value}</span>
      </div>
      }
    },

    {
      field: "col4",
      headerName: "Location",
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        <div tabIndex={0} title={params.value} className="cursor-pointer">
          <span>{params.value}</span>
        </div>
      }
    },
  ];

  const row = [
    {
      id: 1,
      col1: "JSS",
      col2: "BBA",
      col3: "john.doe@example.com",
      col14: "Mathematics",
      col5: "123-456-7890",
      col6: 1,
    },
    {
      id: 2,
      col1: "JSS",
      col2: "BBA",
      col3: "jane.smith@example.com",
      col14: "Physics",
      col5: "987-654-3210",
      col6: 2,
    },
    {
      id: 3,
      col1: "JSS",
      col2: "BBA",
      col3: "alex.johnson@example.com",
      col14: "Chemistry",
      col5: "456-789-1234",
      col6: 3,
    },
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClose1 = () => {
    setOpenAssign(false);
  };
  const getLernersReport = async () => {
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        bpid: userDetails.curprgcou?.bpid,
        pid: userDetails.curprgcou?.pid,
        startDate: startDate,
        endDate: endDate,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    setSpin(true);
    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        `/getLearnersReport`,
        bodyParam
      );

      let loginedUsers = response?.body?.loginedUsers?.length;

      let assignmentsSubmitted = response?.body?.assignmentSubmited?.length;
      console.log("loginedUsers", loginedUsers);

      console.log("assignmentsSubmitted", assignmentsSubmitted);

      let tempRows = [];
      let tempRows1 = [];
      let tempRows2 = [];

      for (let i = 0; i < response?.body?.loginedUsers?.length; i++) {
        let obj1 = {
          id: i,
          col1: response?.body?.loginedUsers[i].UNAME,
          col2: response?.body?.loginedUsers[i].EMAILID,
        };

        console.log("obj1", obj1);
        tempRows1.push(obj1);
      }

      for (let i = 0; i < response?.body?.assignmentSubmited?.length; i++) {
        let obj1 = {
          id: i,
          col1: response?.body?.assignmentSubmited[i].uname,
          col2: response?.body?.assignmentSubmited[i].emailid,
          col3: response?.body?.assignmentSubmited[i].formattedDate,
        };

        console.log("obj1", obj1);
        tempRows2.push(obj1);
      }

      setRowsModal2(tempRows2);
      console.log("tempRows1", tempRows1);
      setRowsModal1(tempRows1);

      let obj = {
        id: 1,
        col1: "JSSHAER",
        col2: userDetails.curprgcou?.pname,
        col3: userDetails.curprgcou?.bname,
        col4: "",
        col5: "",
        col6: "",
        col7: loginedUsers,
        col8: assignmentsSubmitted,
        col9: "",
      };

      tempRows.push(obj);
      setRows(tempRows);
      setShowButton(false);
    } catch (error) {
      console.error(error);
    }

    setSpin(false);
  };

  const handleSearch = (event) => {
    const searchValue = event.target.value.toLowerCase();
    setSearchText(searchValue);
  };

  const filteredUsersLMS = rowsModal1?.filter((row) => {
    const matchesSearch =
      row?.col1.toLowerCase().includes(searchText.toLowerCase()) ||
      row?.col2.toLowerCase().includes(searchText.toLowerCase());

    return matchesSearch;
  });

  const filteredUsersAssign = rowsModal2?.filter((row) => {
    const matchesSearch =
      row?.col1.toLowerCase().includes(searchText.toLowerCase()) ||
      row?.col2.toLowerCase().includes(searchText.toLowerCase());

    return matchesSearch;
  });

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div
            style={{
              width: "80%",
              height: "100",
              overflowY: "auto",
              background: "var(--popup--background)",
              Padding: "30px",
              borderRadius: "5px",
              margin: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "1rem",
              }}
            >
              <h3>LMS Login</h3>

              <Close onClick={handleClose} style={{ cursor: "pointer" }} />
            </div>

            <div
              style={{
                padding: "1rem",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "220px",
                  border: "1px solid rgb(118, 118, 118)",
                  borderRadius: "5px",
                  padding: "2px 8px",
                  backgroundColor: "white",
                }}
              >
                <input
                  type="text"
                  placeholder="Search"
                  onChange={handleSearch}
                  value={searchText}
                  style={{
                    border: "none",
                    height: "fit-content",
                    padding: "2px 1px",
                    fontSize: "12px",
                    width: "px",
                    outline: "none",
                    background: "transparent",
                  }}
                ></input>
                <SearchIcon
                  onClick={() => {}}
                  style={{ color: "#3372b5", height: "20px", width: "20px" }}
                />
              </div>
            </div>
            <div
              style={{ height: 400, width: "100%", padding: "1rem" }}
              className={classes.root}
            >
              <DataGrid
                rows={filteredUsersLMS}
                columns={tcolumnsmodal1}
                className={classes[".MuiDataGrid-root"]}
                disableSelectionOnClick
                sx={{
                  fontSize: "13px",
                }}
                components={{ Toolbar: CustomToolbar }}
                disableColumnMenu
              />
            </div>

            <div style={{ textAlign: "center", padding: "1rem" }}>
              <button
                onClick={handleClose}
                style={{
                  background: Constants.main_color_1,
                  border: "none",
                  borderRadius: "5px",
                  height: "30px",
                  width: "fit-content",
                  color: "var(--button-text)",
                  fontFamily: "nunito",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </Fade>
      </Modal>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openAssign}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openAssign}>
          <div
            style={{
              width: "80%",
              height: "90",
              overflowY: "auto",
              background: "var(--popup--background)",
              Padding: "30px",
              borderRadius: "5px",
              margin: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "2rem",
              }}
            >
              <h3>Assignment Submission</h3>

              <Close onClick={handleClose1} style={{ cursor: "pointer" }} />
            </div>

            <div
              style={{
                padding: "1rem",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "220px",
                  border: "1px solid rgb(118, 118, 118)",
                  borderRadius: "5px",
                  padding: "2px 8px",
                  backgroundColor: "white",
                }}
              >
                <input
                  type="text"
                  placeholder="Search"
                  onChange={handleSearch}
                  style={{
                    border: "none",
                    height: "fit-content",
                    padding: "2px 1px",
                    fontSize: "12px",
                    width: "px",
                    outline: "none",
                    background: "transparent",
                  }}
                ></input>
                <SearchIcon
                  onClick={() => {}}
                  style={{ color: "#3372b5", height: "20px", width: "20px" }}
                />
              </div>
            </div>

            <div
              style={{ height: 400, width: "100%", marginTop: "2rem" }}
              className={classes.root}
            >
              <DataGrid
                rows={filteredUsersAssign}
                columns={tcolumnsmodal2}
                className={classes[".MuiDataGrid-root"]}
                disableSelectionOnClick
                sx={{
                  fontSize: "13px",
                }}
                components={{ Toolbar: CustomToolbar }}
                disableColumnMenu
              />
            </div>

            <div style={{ textAlign: "center", padding: "1rem" }}>
              <button
                onClick={handleClose1}
                style={{
                  background: Constants.main_color_1,
                  border: "none",
                  borderRadius: "5px",
                  height: "30px",
                  width: "fit-content",
                  color: "var(--button-text)",
                  fontFamily: "nunito",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </Fade>
      </Modal>
      <div style={{ display: "flex", gap: "2rem" }}>
        <div style={{ display: "flex", gap: "1rem" }}>
          <h3>Start Date</h3>
          <input
            style={{
              paddingLeft: "5px",
              fontSize: "12px",
              border: "1px solid gray",
              borderRadius: "5px",
            }}
            type="date"
            onChange={(e) => {
              setStartDate(e.target.value);
              setShowButton(true);
            }}
            value={startDate}
            max={formatDate(today)} // Prevent future dates
          />
        </div>
        <div style={{ display: "flex", gap: "1rem" }}>
          <h3>End Date</h3>
          <input
            style={{
              paddingLeft: "5px",
              fontSize: "12px",
              border: "1px solid gray",
              borderRadius: "5px",
            }}
            type="date"
            onChange={(e) => {
              setEndDate(e.target.value);
              setShowButton(true);
            }}
            value={endDate}
            max={formatDate(today)} // Prevent future dates
          />
        </div>

        {showButton && (
          <button
            style={{
              background: Constants.main_color_1,
              border: "none",
              borderRadius: "5px",
              height: "30px",
              width: "fit-content",
              color: "var(--button-text)",
              fontFamily: "nunito",
              fontWeight: "bold",
              fontSize: "16px",
            }}
            onClick={() => {
              getLernersReport();
            }}
          >
            Save
          </button>
        )}
      </div>

      {spin ? (
        <div
          className={classes.root}
          style={{ marginTop: "10rem", marginLeft: "50rem" }}
        >
          <CircularProgress style={{ color: config.main_color_1 }} />
        </div>
      ) : (
        <div
          style={{ height: 400, width: "100%", marginTop: "2rem" }}
          className={classes.root}
        >
          <DataGrid
            rows={rows}
            columns={tcolumns}
            className={classes[".MuiDataGrid-root"]}
            disableSelectionOnClick
            sx={{
              fontSize: "13px",
            }}
            components={{ Toolbar: CustomToolbar }}
            disableColumnMenu
          />
        </div>
      )}
    </div>
  );
};

export default WeeklyReport;
